import React from "react"

import SEO from '../components/SEO'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { ContextProvider } from '../context';


import './layouts.css'
import './react-datepicker.css'
import './index.scss'

const Layout = ({ children, ...props }) => (
  <ContextProvider>
    <SEO {...props} />
    <Header />
    <main>
      {children}
    </main>
    <Footer />
  </ContextProvider>
);

export const ILayout = ({ children, ...props }) => (
  <ContextProvider>
    <SEO {...props} />
    <main>
      {children}
    </main>
  </ContextProvider>
);


export default Layout;
